import React from 'react';
import { mapModifiers } from 'src/libs/component';

interface LoadingProps {
  open?: boolean;
  inblock?: boolean;
  size?: 'extra-small' | 'small' | 'medium' | 'large';
}

export const Loading: React.FC<LoadingProps> = ({ open, inblock, size = 'small' }) => {
  if (inblock) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <div className={mapModifiers('a-loading-inblock', open && 'opened', size)} />
      </div>
    );
  } else {
    return (
      <div className={mapModifiers('a-loading', open && 'opened', size)} />
    );
  }
};
